/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useT } from 'talkr';
import s from './index.module.scss';
import ActionBar from '../../../components/actionBar';

function DescriptionV1() {
  const { T } = useT();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: 'IS_STATUSBAR_TRANSPARENT',
      payload: true,
    });
  });

  return (
    <div className={s.descriptionV1}>
      <div className={s.descriptionV1_text}>
        <div
          className={s.descriptionV1_title}
          dangerouslySetInnerHTML={{ __html: T('customV1_descriptionV1_title') }}
        />
        <div className={s.descriptionV1_description}>{T('customV1_descriptionV1_description')}</div>
      </div>
      <div className={s.descriptionV1_bgs}>
        <div className={s.descriptionV1_bg1} />
        <div className={s.descriptionV1_bg2} />
      </div>
      <ActionBar currentStepCompleted show transparentBg whiteStyle />
    </div>
  );
}

export default DescriptionV1;
